
import '../css/wa.css';
import '../css/monthly.css';


import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import { MdArrowForwardIos } from "react-icons/md";


function Monthly() {
    const navigate = useNavigate();
    const [monthly, setMonthly] = useState([]);
        useEffect(() => {
         const fetch = async () => {
             try {
                 let { data } = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/event`, {
                });
                console.log(data);
                setMonthly(data.results);
            } catch (error) {
                alert('e')
            }
        };
        fetch();
    }, [navigate]);

    return (
        <>
            <div className='mt-center'>
                <div className='mt-main'>
                    <h2>이벤트와 소식</h2>
                    <div className='mt-articles'>
                        {monthly.map((at) => (
                            <div className='mt-article' onClick={() => window.location.href = `/community/article/${at.id}`}>
                                <div className='mt-article-left'>
                                    <div className='mt-article-title'>{at.title}</div>
                                    <div className='mt-article-desc' style={{fontSize:15}}>{at.preview}</div>
                                    <div className='mt-article-desc' style={{color:'gray',fontSize:12}}>{at.date}</div>
                                </div>
                                <div className='mt-article-view'>
                                    읽기 <MdArrowForwardIos/>
                                </div>
                            </div>
                        ))}

                        

                    </div>

                </div>

            </div>
        </>
    );
}                                                                                                      

export default Monthly;
